<script setup lang="ts">
import { computed } from 'vue';
import { useLocale } from '../../../composables/useLocale';
import { BooleanFilter } from '../types';

const { t } = useLocale();

type Props = {
  name: string;
  filter: BooleanFilter;
};
const props = defineProps<Props>();

const model = defineModel<boolean | undefined>({ default: undefined });

const onUpdate = (newValue: boolean | null) => {
  if (model.value === true && newValue === false) {
    model.value = false;
  } else if (model.value === false && newValue === true) {
    model.value = undefined;
  } else if (model.value === undefined || model.value === null) {
    model.value = true;
  }
};

const isIntermediate = computed(() => {
  return model.value === undefined;
});

const label = computed(() => {
  if (isIntermediate.value) {
    return t(props.filter.selectionTransKeys?.intermediate || '');
  }

  return model.value === true
    ? t(props.filter.selectionTransKeys?.true || `lcp.yes`)
    : t(props.filter.selectionTransKeys?.false || `lcp.no`);
});
</script>

<template>
  <v-switch
    :model-value="model"
    :label="label"
    :indeterminate="isIntermediate"
    inset
    hide-details
    color="primary"
    @update:modelValue="onUpdate"
  ></v-switch>
</template>
